import React, { useEffect, useState } from "react";
import {
  Button,
  Flex,
  Loader,
  Radio,
  RadioGroupField,
  TextField,
  Text,
  PasswordField,
  View,
  Icon,
  Alert,
  Badge,
  BadgeVariations
} from "@aws-amplify/ui-react";
import "./Badanti.css";
import { checkBadanteAPI, getBadanteAPI, getFileUrl, modifyBadanteAPI } from "../../data/api";
import BadanteBozzaForm from "./BadanteBozzaForm";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";
import BadanteSchedaFields from "./BadanteSchedaFields";
import { formConfig, getBadgeVariation, recensioneFormConfig } from "./config";
import { format } from "date-fns";
import { Modal } from "react-bootstrap";

const defaultForm = {
  Nome: "",
  Cognome: "",
  Telefono: "+39",
  Numero_Identificativo: "-",
  Recensioni: []
};

const BadanteScheda = (props) => {
  const [loading, setLoading] = useState(true);
  const [emptyState, setEmptyState] = useState(false);
  const [error, setError] = useState(false);
  const [loadingContratto, setLoadingContratto] = useState(false);
  const [errorContratto, setErrorContratto] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const idBadante = queryParams.get('id');

  // modify BadanteBozza form data
  const [badante, setBadante] = useState(defaultForm); // the data on the DB

  const getBadante = async (id) => {    
    try{
      setLoading(true);
      setEmptyState(false);
      setError(false);
      const badanteResponse = await getBadanteAPI(id);
      setBadante(badanteResponse);
      setLoading(false);
    } catch (e) {
      if(e.statusCode === 404){
        setEmptyState(true);
      } else {
        console.log('Loading badante '+id+' failed ', e);
        setError(true);
      }
      setLoading(false);
    }
  }

  // new recensione for "non considerare" button
  const [recensioni, setRecensioni] = useState([]);

  // alert permesso soggiorno
  const [showAlertPermessoSoggiorno, setShowAlertPermessoSoggiorno] = useState(false);
  useEffect(() => {
    setShowAlertPermessoSoggiorno(
      (badante['Italiano'] === 'No' &&
        badante['Comunita_Europea'] === 'No') &&
      (badante['Documenti'] ?? []).map(d => d.Tipo).find(t => t === 'Permesso di soggiorno' || t === 'Visto') === undefined
    )
  }, [badante]);

  // alert documento riconoscimento
  const [showAlertDocumenti, setShowAlertDocumenti] = useState(false);
  useEffect(() => {
    setShowAlertDocumenti(
      (badante['Documenti'] ?? []).map(d => d.Tipo).find(t => t === 'Carta di identità' || t === 'Passaporto' || t === 'Patente') === undefined
    )
  }, [badante]);

  const setAttivo = async (attivo) => {
    try{
      setLoading(true);
      // check if documentazione is completa
      if(attivo == 'Disponibile' && (showAlertPermessoSoggiorno || showAlertDocumenti)){
        attivo = 'Incompleto'
      }
      await modifyBadanteAPI({...badante, Attivo: attivo, Recensioni: [...badante.Recensioni, ...((recensioni as any).Recensioni ?? [])]});
      getBadante(idBadante);
      setRecensioni([]);
    } catch (e) {
      console.log('Modify Badante Attivo failed ', e);
      setLoading(false);
    }
  }

  useEffect(() => {
    getBadante(idBadante);
  }, []);

  const changeBadante = (e) => {
    const { name, value } = e.target;
    const newValue = { ...badante };
    name.split('.').reduce((acc, key, idx, arr) => 
      acc[key] = idx === arr.length - 1 ? value : acc[key] || {}, newValue);
    setBadante(newValue);
    modifyBadante(newValue);
  };

  const changeRecensioni = (e) => {
    const { name, value } = e.target;
    const newValue = { ...recensioni };
    name.split('.').reduce((acc, key, idx, arr) => 
      acc[key] = idx === arr.length - 1 ? value : acc[key] || {}, newValue);
    setRecensioni(newValue);
  };

  const updateContratto = (contratto, contrattoEsteso) => {
    const newValue = { ...badante, Contratto: contratto, Contratto_Esteso: contrattoEsteso };
    setBadante(newValue);
    modifyBadante(newValue);
  };

  const modifyBadante = async (badante) => {
    try{
      setLoading(true);
      setError(false);
      await modifyBadanteAPI(badante);
      setLoading(false);
      getBadante(idBadante)
    } catch (e) {
      console.log('Modify Badante Bozza failed ', e);
      setError(true);
      setLoading(false);
    }
  };

  const [showAlertContratto, setShowAlertContratto] = useState(false);
  useEffect(() => {
    if((badante as any).Data_Generazione_Contratto === null){
      setShowAlertContratto(false);
    } else {
      const dateUltimaModifica = new Date((badante as any).Data_Modifica_Campi_Obbligatori);
      const dateGenerazioneContratto = new Date((badante as any).Data_Generazione_Contratto);
      setShowAlertContratto(dateUltimaModifica > dateGenerazioneContratto ?? false);
    }
  }, [badante]);

  // handle print scheda
  const [isLoadingScheda, setIsLoadingScheda] = useState(false);
  const [isErrorScheda, setIsErrorScheda] = useState(false);
  const printScheda = async () => {
    setIsLoadingScheda(true)
    setIsErrorScheda(false)
    try{  
      window.open(await getFileUrl((badante as any).Contratto), "_blank");
      setIsLoadingScheda(false)
      setIsErrorScheda(false)
    } catch (e) {
      console.log('Print scheda failed ', e);
      setIsLoadingScheda(false)
      setIsErrorScheda(true)
    }
  };

  // modal state
  const [showModal, setShowModal] = useState(false);

  return (
    <View maxWidth="100%" padding="0rem" minHeight="100vh">
      <View
        backgroundColor="var(--amplify-colors-white)"
        borderRadius="6px"
        maxWidth="100%"
        padding="1rem"
      >
        <View marginBottom="10px">
            <NavLink to='/os' className="amplify-link"><Icon as={MdArrowBack}></Icon> Torna indietro</NavLink>
        </View>
      {
        loading ? <Loader/> : 
        error ? <Alert variation="error">Errore nel caricamento dei dati</Alert> : 
        emptyState ? <Alert variation="info">Badante non trovato</Alert> :
        <>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px'
          }}>
            <h2>Scheda di {badante?.Cognome} {badante?.Nome}</h2>
            <View>
              <Button
                disabled={isLoadingScheda || (badante as any).Contratto === null}
                onClick={() => printScheda()}
                width={"fit-content"}
                alignSelf={"right"}
              >
                {isLoadingScheda ? <Loader/> : "Stampa scheda OS"}
              </Button>
              <Button onClick={() => navigate('/os/edit?id='+idBadante)} marginLeft="15px" >Modifica dati</Button>
              {badante['Attivo'] === 'Da non considerare' ? 
                <Button variation="primary" marginLeft="15px" onClick={() => setAttivo('Disponibile')}>
                  Imposta come disponibile
                </Button>
                :
                <Button variation="warning" marginLeft="15px" onClick={() => setShowModal(true)}>
                  Non considerare più
                </Button>
              }
              <View>{ isErrorScheda && <span style={{color: "red", marginLeft: "auto"}}>Errore stampa!</span>}</View>
            </View>
        </div>
        {(showAlertContratto) && <Alert variation="warning" marginBottom="10px">Attenzione: i dati della scheda sono stati modificati, è necessario generare nuovamente la scheda per aggiornarla.</Alert>}
        <View>
            Numero identificativo: <b>{badante.Numero_Identificativo ?? '-'}</b>
            <br/>Stato di occupazione: <Badge variation={getBadgeVariation(badante['Attivo']) as BadgeVariations}>
              {badante['Attivo'] ?? '-'}
            </Badge>
            <br/>Data di disponibilità: <b>{badante['Data_Disponibilita'] ?? '-'}</b>
            <br/>Data ultima modifica: <b>{badante['Data_Update'] ?? '-'}</b><br/><br/>
        </View>
          <BadanteSchedaFields
              value={badante}
              savedValue={badante}
              onChange={changeBadante}
              onGenerateContratto={(contratto, contrattoEsteso) => updateContratto(contratto, contrattoEsteso)}>
          </BadanteSchedaFields>
        </>
      }
      </View>
      <Modal show={showModal} onHide={() => setShowModal(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Imposta OS come "da non considerare"</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Text>Per procedere, inserire almeno una referenza per l'OS.</Text>
          <br/>
          <BadanteBozzaForm
            formConfig={recensioneFormConfig}
            value={recensioni}
            savedValue={recensioni}
            onChange={changeRecensioni}>
          </BadanteBozzaForm>
        </Modal.Body>
        <Modal.Footer>
          <Button variation="primary" isDisabled={!((recensioni as any)?.Recensioni?.length > 0 )} onClick={() => {setAttivo('Da non considerare'); setShowModal(false)}}>
            Salva e non considerare più
            </Button>
        </Modal.Footer>
      </Modal>
    </View>
  );
};

export default BadanteScheda;